import React from 'react';
import './category.css';
import { categoryImagesData } from '../../Hooks/categoryImages';

const Category = ({ onNavigate }) => {
  const handleCategoryClick = (categorySlug, categoryName) => {
    if (onNavigate) {
      onNavigate('products', categorySlug, categoryName);
    }
  };
  return (
    <div className="content-section">
      <div className="category-grid">
        {categoryImagesData.map((category) => (
          <div 
            key={category.id} 
            className="category-card"
            onClick={() => handleCategoryClick(category.slug, category.name)}
            style={{ cursor: 'pointer' }}
          >
            <img 
              className='category-image' 
              src={category.mainImage} 
              alt={category.name} 
              loading={category.id <= 6 ? "eager" : "lazy"} 
              decoding="async" 
              fetchPriority={category.id <= 6 ? "high" : undefined}
            />
            <h3>{category.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Category;
